import { render, staticRenderFns } from "./PageNewApolice.vue?vue&type=template&id=1585892e"
import script from "./PageNewApolice.vue?vue&type=script&lang=js"
export * from "./PageNewApolice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports